export default __webpack_public_path__ + "media/images/playbutton-d041c3cd77f35bbf81e76655a6032729.svg";